import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-venta-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent{
  persona = null;
  tamano = document.body.clientHeight;
  calcular_importe_articulo(item, json) {
    // sumamos las cantidades
    let total = 0; let c = 0; let restante = 0; let descuento = 0;

    json.movimientos_articulos.forEach(element => {
      let importe_desc = element.cantidad * element.precio_unitario;
      element.importe = element.cantidad * element.precio_unitario;
      if (element.descuento > 0) {
        let desc = element.descuento / 100;
        element.precio_con_descuentos = importe_desc - (importe_desc * desc);
        descuento += importe_desc * desc;
      }

      total = total + (element.cantidad * element.precio_unitario);

      json.importe = (element.importe);
      json.precio_con_descuentos = (element.precio_con_descuentos);
      c++;
    });

    let importe = 0;
    let cambio = 0;
    let i = 0;
    json.pagos.forEach(element => {
      importe = importe + element.paga_con;
    });

    json.subtotal = total;
    json.descuento = descuento;
    json.total = total - descuento;
    json.total_recibido = importe;
    json.cambio = importe - (total - descuento);

    document.getElementById("imprimirTicket").click();
  }
}
